/* eslint-disable react/display-name */
import React, { useReducer, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { getInitialState, stateReducer } from './appReducer';

const AppContext = React.createContext();

export const AppContextComponent = ({ children, data }) => {
  const defaultState = getInitialState();
  const appData = {
    ...defaultState,
    ...data,
  };

  const [store, dispatch] = useReducer(stateReducer, appData);

  const state = useMemo(
    () => ({
      dispatch,
      store,
    }),
    [store],
  );

  return <AppContext.Provider value={state}>{children}</AppContext.Provider>;
};

export const withContext = (newProps = {}) => (ChildComponent) => (props) => (
  <AppContext.Consumer>
    {(context) => (
      <ChildComponent {...context} {...newProps} {...props} />
    )}
  </AppContext.Consumer>
);

export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error(
      'useAppContext or AppContext.Consumer cannot be rendered outside the AppContext.Provider components',
    );
  }

  return context;
};

AppContextComponent.propTypes = {
  children: PropTypes.shape(),
  data: PropTypes.shape(),
};

AppContextComponent.defaultProps = {
  children: undefined,
  data: undefined,
};
